/**
 * VoiceWaves Komponente
 * Animierte Wellenbalken für Sprachaktivitätsanzeige
 */

import { memo } from 'react';

interface VoiceWavesProps {
  active: boolean;
  className?: string;
}

export const VoiceWaves = memo(function VoiceWaves({ active, className = '' }: VoiceWavesProps) {
  return (
    <div className={`flex items-center justify-center gap-1 h-8 ${className}`}>
      {Array.from({ length: 5 }, (_, i) => (
        <div
          key={i}
          className={`w-1 rounded-full transition-all duration-150 ${
            active ? 'bg-cherry-500 animate-pulse' : 'bg-charcoal-300'
          }`}
          style={{
            height: active ? `${16 + Math.sin(i * 0.8) * 8}px` : '8px',
            animationDelay: `${i * 100}ms`,
          }}
        />
      ))}
    </div>
  );
});

export default VoiceWaves;
